import { Controller } from "react-hook-form";
import { lang } from "../../Utils/lang";
import { TextField } from "@mui/material";

export default function AdministrativeLocationData(props: any) {
  const { control } = props;

  return (
    <>
      <Controller
        name="nume"
        defaultValue={undefined}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <TextField
            onChange={onChange}
            fullWidth
            style={{
              marginBottom: 15,
            }}
            value={value}
            error={!!error}
            helperText={error?.message}
            id="nume"
            label={lang.locationName}
            size="small"
            variant="outlined"
          />
        )}
      />
      <Controller
        name="adresa"
        defaultValue={undefined}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <TextField
            onChange={onChange}
            fullWidth
            style={{
              marginBottom: 15,
            }}
            value={value}
            error={!!error}
            helperText={error?.message}
            id="adresa"
            label={lang.address}
            size="small"
            variant="outlined"
          />
        )}
      />
      <Controller
        name="judet"
        defaultValue={undefined}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <TextField
            onChange={onChange}
            fullWidth
            style={{
              marginBottom: 15,
            }}
            value={value}
            error={!!error}
            helperText={error?.message}
            id="judet"
            label={lang.county}
            size="small"
            variant="outlined"
          />
        )}
      />
      <Controller
        name="telefon"
        defaultValue={undefined}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <TextField
            onChange={onChange}
            fullWidth
            style={{
              marginBottom: 15,
            }}
            value={value}
            error={!!error}
            helperText={error?.message}
            id="telefon"
            label={lang.phoneNumber}
            size="small"
            variant="outlined"
          />
        )}
      />
    </>
  );
}
